/**
 * The drawing of a TJN signal or sign from DIM UI (found by the data's code or the paragraph),
 * else the generated glyph of its concept: one picture for the glance card, the facts and the hero.
 */

import { TjnSignal, findTjn } from '@bn-apps/dim-ui-react/tjn';
import { paragraphOf, type Concept } from '@services/vocabulary.service';
import { Glyph } from './alongTrack';
import styles from './tjn.module.scss';

export function tjnNames(concept: Concept, code: string): string[] {
  const paragraph = paragraphOf(concept);
  return [/^\d+[A-Z]$/.test(code) ? code : null, paragraph].filter((name): name is string =>
    Boolean(name)
  );
}

/** The TJN drawing for a bare code (68B, §8-54), for when the vocabulary has not loaded or lacks it. */
export function tjnByCode(code: string): string | null {
  return findTjn(code)?.id ?? null;
}

export function TjnPicture({
  concept,
  code,
  value,
  className,
}: {
  concept: Concept;
  code: string;
  value?: string;
  className?: string;
}): JSX.Element | null {
  const entry = tjnNames(concept, code)
    .map((name) => findTjn(name))
    .find(Boolean);
  if (entry) {
    return (
      <TjnSignal
        signal={entry.id}
        value={value}
        label=""
        size={30}
        className={className ? `${styles.tjn} ${className}` : styles.tjn}
      />
    );
  }
  return concept.symbol ? (
    <svg width="36" height="48" viewBox="0 0 18 24" aria-hidden="true" className={className}>
      <Glyph symbol={concept.symbol} x={9} y={23} />
    </svg>
  ) : null;
}
